<script lang="ts">
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { DistributorEntity, ProductEntity } from "@shared/services/event_tracking/entities";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let distributor;
  export let product;

  const { trackMrcEvents } = EventTracking;
  const trackingParams = [new ProductEntity(product), new DistributorEntity(distributor)];

  // Needed to control when view event fires
  $: tooltipHovered = false;
</script>

<style>
  .tooltip-text {
    border-bottom: 1px dashed #595959;
    font-weight: 400;
  }
</style>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div class="fizz-tooltip-container" data-testid="no-recent-update-tooltip">
    <span
      class="tooltip-text fizz-tooltip-trigger fizz-text-subdued"
      aria-describedby="no-update-tooltip"
      on:mouseenter={() => (tooltipHovered = true)}
      on:mouseleave={() => (tooltipHovered = false)}
    >
      No recent inventory update
    </span>
    {#if tooltipHovered}
      <div
        class="fizz-tooltip fizz-tooltip-top"
        class:fizz-tooltip-center={$LayoutStore.isDesktop}
        role="tooltip"
        id="no-update-tooltip"
        use:trackMrcEvents={[trackingContext.entities]}
      >
        This distributor has not shared inventory levels with Provi recently.
      </div>
    {/if}
  </div>
</TrackingContext>
